import "./src/styles/bootstrap/main.scss"
import "./src/styles/global.css"
import React from "react"
import RootWrapper from "./src/components/consent/rootWrapper"
import { trackPageView } from "./src/utils/analytics"

export const wrapRootElement = ({ element }) => <RootWrapper element={element} />

// Count page changes inside the site (only sends something after consent).
// The short delay lets the new page set its title first.
export const onRouteUpdate = ({ prevLocation }) => {
  if (prevLocation) setTimeout(trackPageView, 50)
}
